// extracted by mini-css-extract-plugin
export default {"AutoChoiceRadio":"autoKeyword_AutoChoiceRadio__cos-d"};